export { default } from './RatePage';
